import { render, staticRenderFns } from "./BreadCrumbs.vue?vue&type=template&id=79c683c8&scoped=true&"
import script from "./BreadCrumbs.vue?vue&type=script&lang=js&"
export * from "./BreadCrumbs.vue?vue&type=script&lang=js&"
import style0 from "./BreadCrumbs.vue?vue&type=style&index=0&id=79c683c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c683c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79c683c8')) {
      api.createRecord('79c683c8', component.options)
    } else {
      api.reload('79c683c8', component.options)
    }
    module.hot.accept("./BreadCrumbs.vue?vue&type=template&id=79c683c8&scoped=true&", function () {
      api.rerender('79c683c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/BreadCrumbs.vue"
export default component.exports